import axiosInstance from '../../../config/axiosInstance';
const InvoiceService = {
    async GetAllInvoice(redirectCallback, ClientCompanyID, Start, PageSize, searchQuery, sortColumn, sortDirection,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Invoice/GetInvoice?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetInvoiceCount(redirectCallback, ClientCompanyID, searchQuery,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Invoice/GetInvoiceCount?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&searchQuery=${searchQuery}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllParts(redirectCallback, ClientCompanyID = 0) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllParts?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetInvoiceType(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Invoice/GetInvoiceTypes`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetInvoiceByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Invoice/GetInvoiceByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetInvoiceItem(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Invoice/GetInvoiceItem?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async DeleteInvoice(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Invoice/DeleteInvoice?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async AllocateInvoice(formData) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            const response = await axiosInstance.post(`/Invoice/AllocateInvoice`, formData);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetInvoiceNo(ID, InvoiceID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Invoice/SetInvoiceNo?ID=${ID}&InvoiceID=${InvoiceID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async ShipInvoice(formData) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            debugger;
            const response = await axiosInstance.post(`/Invoice/ShipInvoice`, formData);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetInvoiceItemHistory(redirectCallback, InvoiceItemID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Invoice/InvoiceItemsHistory?InvoiceItemID=${InvoiceItemID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UnAllocateInvoice(InvoiceID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/Invoice/UnAllocateInvoice?InvoiceID=${InvoiceID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async PayInvoice(InvoiceID, Amount) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Invoice/PayInvoice?InvoiceID=${InvoiceID}&UserID=${UserID}&Amount=${Amount}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
     async PrintInvoice(InvoiceID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Invoice/PrintInvoice?InvoiceID=${InvoiceID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async CustomerInvoiceRecord(ClientCompanyID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/Invoice/CustomerInvoiceRecord?ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LockInvoice(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Invoice/LockInvoice?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockInvoice(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Invoice/UnLockInvoice?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SyncInvoiceToFinancial(ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Customer/SyncCustomerToFinancialApp?ID=${idString}&ClientID=${ClientID}&UserID=${UserID}&action=Invoice`);
            if (response.data) {
                if (response.data.authUrl) {
                    // Open QuickBooks auth popup
                    const authPopup = window.open(
                        response.data.authUrl,
                        'QuickbookAuth',
                        'width=600,height=700,top=100,left=100'
                    );

                    if (!authPopup) {
                        throw new Error('Popup blocked. Please enable popups.');
                    }

                    // Polling to wait for user to close the popup
                    const interval = setInterval(() => {
                        if (authPopup.closed) {
                            clearInterval(interval);
                            console.log('Popup closed. Retrying QuickBooks customer creation...');
                            // Retry once popup is closed
                            //  this.QuickbookAddCustomer(ClientCompanyID);
                        }
                    }, 500);
                    return;
                } else {
                    // Success case
                    return response.data;
                }
            }

        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetPaymentTerms() {
        try {
            const response = await axiosInstance.get(`/Invoice/GetPaymentTerms`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
     async GetPaymentRecord(InvoiceID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const response = await axiosInstance.get(`/Invoice/GetPaymentRecord?InvoiceID=${InvoiceID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async CustomerInvoiceAgedSummary(ClientCompanyID) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
          
            const response = await axiosInstance.get(`/Invoice/CustomerInvoiceAgedSummary?ClientCompanyID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default InvoiceService;